import RoutesNames from "@/routes/RoutesNames";

export const tabNames = {
  simulator: "",
  proposals: "propostas",
};

export const tabRoutes = {
  [tabNames.simulator]: RoutesNames.ROOT,
  [tabNames.proposals]: RoutesNames.PROPOSALS,
};

export const tabIdFromPathname = (pathname: string) =>
  Object.entries(tabRoutes).find(
    ([, route]) =>
      route !== RoutesNames.ROOT &&
      (pathname === route || pathname.startsWith(`${route}/`)),
  )?.[0] ?? tabNames.simulator;
